import React from 'react';

interface SecurSpacePageTitleProps {
  children?: React.ReactNode;
}

const SecurSpacePageTitle = (props: SecurSpacePageTitleProps) => {
  const {children} = props;

  return <header>
    <div className={'flex justify-content-center'}>
      <div className={'flex'}>
        <h1 className={'content-header-title'}>
          {children}
        </h1>
      </div>
    </div>
  </header>
}

export default SecurSpacePageTitle;
